module.exports = __webpack_public_path__ + "static/media/icon_clipboard-provblue.d617274e.png";